import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { Mode, Validate } from 'core/slices/session';
import { ValidateState } from 'types/session/auth';

const validate = (state: RootState) => state.session.validate;

export const selectSessionValidated = createSelector([validate], (validate: Validate) => {
  return validate.state === ValidateState.VALIDATED;
});
